<template>
    <div class="rates-container">
        <div class="filter-title">
            <typo name="body-14-light">Unité du taux </typo>
        </div>
        <div class="search-rate-unit-container">
            <v-select
                v-model="unit"
                :items="unitItems"
                item-text="label"
                item-value="code"
                append-icon="mdi-chevron-down"
                clearable
                outlined
                dense
                class="rounded-0"
            />
        </div>
    </div>
</template>

<script>
import { get } from "lodash";

export default {
    props: ["value", "annotationOptions"],
    data() {
        return {
            unit: this.getUnit(),
        };
    },
    methods: {
        getUnit() {
            return this.value;
        },
    },
    watch: {
        async unit(value) {
            this.$emit("input", value);
        },
        value(_value) {
            this.unit = _value ? _value : null;
        },
    },
    computed: {
        unitItems() {
            return Object.keys(this.annotationOptions)
                .map(key => {
                    return this.annotationOptions[key]["type"] === "unit"
                        ? {
                              code: key,
                              label: get(this.annotationOptions, `${key}.label`, "").toLowerCase(),
                          }
                        : null;
                })
                .filter(v => v !== null);
        },
    },
};
</script>

<style lang="sass" scoped>
.rates-container
    display: flex
    align-items: center

.filter-title
    margin-left: 50px
    margin-right: 10px

.search-rate-unit-container
    width: 200px
    margin: 0 8px
</style>
